<template lang="pug">
  .tag-description-container(@contextmenu.prevent="showDescription")
    transition(name="tag-description")
      .tag-description-text.no-wrap(v-if="show" :class="{'tag': isTag}") {{ description }}
    slot.tag.no-select
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      required: true
    },
    isTag: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      show: false,
      timeout: null,
      timeToHide: 5000
    }
  },

  methods: {
    showDescription () {
      this.show = true

      setTimeout(() => {
        this.show = false
      }, this.timeToHide)
    }
  }
}
</script>

<style lang="stylus" scoped>
.tag-description-container
  position relative
  cursor pointer

.tag-description-text
  position absolute
  transform translateY(-150%)
  opacity 1

.tag-description-enter-active, .tag-description-leave-active
  transition transform 0.5s ease, opacity 0.5s ease

.tag-description-enter
  transform translateY(0)
  opacity 0

.tag-description-enter-to
  transform translateY(-150%)
  opacity 1

.tag-description-leave
  transform translateY(-150%)
  opacity 1

.tag-description-leave-to
  transform translateY(0)
  opacity 0
</style>



// WEBPACK FOOTER //
// src/components/elements/TagDescription.vue